import { render, staticRenderFns } from "./ControlInput.vue?vue&type=template&id=b8275698&"
import script from "./ControlInput.vue?vue&type=script&lang=js&"
export * from "./ControlInput.vue?vue&type=script&lang=js&"
import style0 from "./ControlInput.vue?vue&type=style&index=0&id=b8275698&prod&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports